import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStack12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconImageStack12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-7a.5.5 0 0 0-.5.5V3h5.5A1.5 1.5 0 0 1 10 4.5V8h.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5M10 9h.5A1.5 1.5 0 0 0 12 7.5v-5A1.5 1.5 0 0 0 10.5 1h-7A1.5 1.5 0 0 0 2 2.5V3h-.5A1.5 1.5 0 0 0 0 4.5v5A1.5 1.5 0 0 0 1.5 11h7A1.5 1.5 0 0 0 10 9.5zM9 9V4.5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v3.746L2.652 6.64l.381-.37.347.404L6.23 10H8.5a.5.5 0 0 0 .5-.5zM2.967 7.73 4.913 10H1.5a.5.5 0 0 1-.484-.375zM7 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStack12);
